
import Vue from 'vue'
import ConditionColor from '../components/ConditionColor.vue';
import { Colors } from '@/shared/models/condition.model';

export default Vue.extend({
    name: 'IntroductionText',

    components: {
        ConditionColor
    },

    data() {
        return {
            green: Colors.Green,
            yellow: Colors.Yellow,
            mixed: Colors.Mixed
        }
    },
})
